import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const auth = token => ({ headers: token ? { Authorization: `Bearer ${token}` } : {} });

/**
 * Owner dashboard (GET /api/dashboard). `from`/`to` are "YYYY-MM-DD"; leave both
 * out for the server's business day ("Today" is cut at business_day_start, which
 * only the server knows for certain).
 */
const range = ({ from, to } = {}) => (from && to ? { from_date: from, to_date: to } : {});

export async function getDashboard({ from, to, itemsBy = "qty" } = {}, token) {
  const res = await axios.get(`${API}/dashboard`, { ...auth(token), params: { ...range({ from, to }), items_by: itemsBy } });
  return res.data;
}

export async function getLeakageRows(line, period, token) {
  const res = await axios.get(`${API}/dashboard/leakage/${line}`, { ...auth(token), params: range(period) });
  return res.data;
}

export async function getOutflowRows(kind, period, token) {
  const res = await axios.get(`${API}/dashboard/outflow/${kind}`, { ...auth(token), params: range(period) });
  return res.data;
}

export async function getIncidents(token) {
  const res = await axios.get(`${API}/dashboard/incidents`, auth(token));
  return res.data;
}

export async function ackIncident(key, token) {
  const res = await axios.post(`${API}/dashboard/incidents/${encodeURIComponent(key)}/ack`, {}, auth(token));
  return res.data;
}

export async function getTargets(token) {
  const res = await axios.get(`${API}/dashboard/targets`, auth(token));
  return res.data;
}

export async function setTarget(body, token) {
  const res = await axios.post(`${API}/dashboard/targets`, body, auth(token));
  return res.data;
}

export async function importAggregatorCSV(formData, token) {
  const res = await axios.post(`${API}/dashboard/aggregator/import`, formData, {
    ...auth(token),
    headers: { ...auth(token).headers, "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export async function getAggregatorBatches(token) {
  const res = await axios.get(`${API}/dashboard/aggregator/batches`, auth(token));
  return res.data;
}

export async function getCashCounts(day, token) {
  const res = await axios.get(`${API}/register/days/${day}/counts`, auth(token));
  return res.data;
}
